import http from "../app/httpService";

const apiEndpoint = process.env.REACT_APP_MARKET_DATA_API + "TradeConfirmation/";

export async function getTradeConfirmation(tradeConfirmationId, actingOrganizationId) {
  const query = actingOrganizationId ? "?actingOrganizationId=" + actingOrganizationId : "";
  const { data: confirmation } = await http.get(apiEndpoint + tradeConfirmationId + query);
  return confirmation;
}

export async function getTradeConfirmationByEngineTrade(engineTradeId, actingOrganizationId) {
  const query = actingOrganizationId ? "?actingOrganizationId=" + actingOrganizationId : "";
  const { data: confirmation } = await http.get(apiEndpoint + "EngineTrade/" + engineTradeId + query);
  return confirmation;
}

export async function getTradeConfirmationVersions(tradeConfirmationId, actingOrganizationId) {
  const query = actingOrganizationId ? "?actingOrganizationId=" + actingOrganizationId : "";
  const { data: versions } = await http.get(apiEndpoint + tradeConfirmationId + "/Versions" + query);
  return versions;
}

export async function getTradeConfirmationStatuses(engineTradeIds, actingOrganizationIds) {
  const { data: statuses } = await http.post(apiEndpoint + "Status", {
    engineTradeIds,
    actingOrganizationIds,
  });
  return statuses;
}

export async function saveTradeConfirmation(confirmation) {
  const { data: savedConfirmation } = await http.post(apiEndpoint, confirmation);
  return savedConfirmation;
}

export async function acceptTradeConfirmation(action) {
  const { data: confirmation } = await http.put(apiEndpoint + "Accept", action);
  return confirmation;
}

export async function rejectTradeConfirmation(action) {
  const { data: confirmation } = await http.put(apiEndpoint + "Reject", action);
  return confirmation;
}

export async function cancelTradeConfirmation(action) {
  const { data: confirmation } = await http.put(apiEndpoint + "Cancel", action);
  return confirmation;
}

export async function uploadTradeConfirmationAttachment(tradeConfirmationId, fieldDefinitionId, file) {
  const formData = new FormData();
  formData.append("file", file);

  const { data: attachment } = await http.post(
    apiEndpoint + tradeConfirmationId + "/Attachments/" + fieldDefinitionId,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return attachment;
}
